const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL || "http://localhost:8000";
import { getSessionHeaders } from "@/components/utils";
import { SidebarData } from "@/common/interface/console";
import { OperatorOptions } from "@/common/interface/console";

export async function getSidebarData(): Promise<SidebarData> {
  const response = await fetch(`${API_BASE_URL}/console/sidebar`, {
    method: "GET",
    credentials: "include",
    headers: getSessionHeaders(),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.message || "사이드바 데이터를 가져오는데 실패했습니다."
    );
  }

  const data = await response.json();
  return data;
}

export async function updateOperatorOptions(
  type: string,
  action: string
): Promise<OperatorOptions> {
  const response = await fetch(`${API_BASE_URL}/console/operator/${type}/${action}`, {
    method: "PATCH",
    credentials: "include",
    headers: getSessionHeaders(),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.message || "운영자 정보를 가져오는데 실패했습니다."
    );
  }

  return await response.json();
}
